import types from '../mutations/mutation-types'
import { GeneralActions } from '../actions/'

export default {
  state: {
    countryAndLanguages: {},
    allApps: {},
    keywords: []
  },
  mutations: {
    [types.GENERAL.LOAD_LANGUAGES] (state, languages) {
      state.countryAndLanguages = languages
    },
    [types.GENERAL.LOAD_APPS] (state, allApps) {
      state.allApps = allApps
    },
    [types.GENERAL.LOAD_KEYWORDS] (state, keywords) {
      state.keywords = keywords
    }
  },
  actions: GeneralActions
}



// WEBPACK FOOTER //
// ./src/store/modules/general.js